var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100", class: _vm.moduleClasses }, [
    _c("div", { class: _vm.cardClasses }, [
      _c("div", { staticClass: "row flex-sm-nowrap h-100 no-gutters m-0" }, [
        _vm.showImageModule
          ? _c(
              "div",
              { staticClass: "col-auto col-sm-4 col-lg-5 col-xl-4 col-xxl-3" },
              [
                _c("img", {
                  staticClass: "card-img",
                  attrs: {
                    loading: "lazy",
                    src: _vm.module.image,
                    alt: _vm.moduleName,
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12",
            class: [
              _vm.showImageModule ? "col-sm-8 col-lg-7 col-xl-8 col-xxl-9" : "",
            ],
          },
          [
            _c(
              "div",
              {
                staticClass: "card-block d-flex flex-column h-100",
                class: [
                  { "px-3 pt-3": _vm.showImageModule },
                  _vm.showImageModule
                    ? _vm.enableNotificationsArrow
                      ? "pb-2"
                      : "pb-3"
                    : "",
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "card-header p-0 bg-transparent border-0" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "media",
                        class: _vm.showImageModule
                          ? "d-block"
                          : "flex-row flex-nowrap",
                      },
                      [
                        _vm.showIconModule
                          ? _c("img", {
                              staticClass: "align-self-center mr-3",
                              attrs: {
                                loading: "lazy",
                                src: _vm.module.icon,
                                alt: _vm.moduleName,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.moduleName) +
                              "\n                            "
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body p-0" }, [
                  _c("p", { staticClass: "card-text block-with-text" }, [
                    _vm._v(_vm._s(_vm.module.description)),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-footer p-0 bg-transparent border-0" },
                  [
                    _vm.notifications || _vm.enableNotificationsArrow
                      ? _c(
                          "nav",
                          {
                            staticClass: "navbar navbar-white navbar-light p-0",
                          },
                          [
                            _c("ul", { staticClass: "navbar-nav w-100" }, [
                              _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "nav-link d-flex flex-nowrap justify-content-between py-1",
                                    class: {
                                      "has-notification":
                                        _vm.notifications.num > 0,
                                    },
                                    attrs: { href: "#" },
                                  },
                                  [
                                    _c("div", { staticClass: "d-flex" }, [
                                      _vm.enableNotificationsIcon
                                        ? _c("div", { staticClass: "pr-2" }, [
                                            _c("i", {
                                              staticClass: "far fa-bell",
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "badge badge-danger navbar-badge",
                                            }),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "card-text" }, [
                                        _vm._v(_vm._s(_vm.notifications.text)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _vm.enableNotificationsArrow
                                      ? _c(
                                          "div",
                                          { staticClass: "text-right" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                loading: "lazy",
                                                src: _vm.notificationImage,
                                                alt: _vm.notificationImageAlternateText,
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }